/**
 * Cart Count Auto-Update Fix
 * Ensures cart count badges update when third-party apps (like Candyrack) add items to cart
 */

(function() {
  'use strict';

  let isPolling = false;

  const updateAllCartCounts = async () => {
    try {
      const timestamp = new Date().getTime();
      const response = await fetch('/cart.js?t=' + timestamp);
      if (!response.ok) return;

      const cart = await response.json();
      const cartCountElements = document.querySelectorAll('cart-count');
      const currentDisplayedCount = cartCountElements[0] ? parseInt(cartCountElements[0].textContent) : 0;

      if (cart.item_count === currentDisplayedCount) {
        return;
      }

      cartCountElements.forEach((element) => {
        if (element) {
          element.textContent = cart.item_count;
          element.innerText = cart.item_count;

          if (cart.item_count === 0) {
            element.setAttribute('hidden', '');
            element.hidden = true;
          } else {
            element.removeAttribute('hidden');
            element.hidden = false;
          }

          const ariaLabel = element.getAttribute('aria-label');
          if (ariaLabel) {
            const newLabel = ariaLabel.replace(/\d+/, cart.item_count);
            element.setAttribute('aria-label', newLabel);
          }
        }
      });
    } catch (error) {
      console.warn('Cart count update error:', error);
    }
  };

  const pollCartCount = () => {
    if (isPolling) return;
    isPolling = true;

    setTimeout(() => updateAllCartCounts(), 500);
    setTimeout(() => updateAllCartCounts(), 1000);
    setTimeout(() => updateAllCartCounts(), 1500);
    setTimeout(() => updateAllCartCounts(), 2000);
    setTimeout(() => {
      updateAllCartCounts();
      isPolling = false;
    }, 3000);
  };

  const monitorCartChanges = () => {
    const previousFetch = window.fetch;

    window.fetch = function(...args) {
      const url = args[0];

      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
        pollCartCount();
      }

      return previousFetch.apply(this, args);
    };

    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        pollCartCount();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', monitorCartChanges);
  } else {
    monitorCartChanges();
  }

})();
